import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { matchingRangeState } from "../pages/Party/MatchingInfo/MatchingInfoFilter";
import RangeModal from "./RangeModal";

interface RangeSliderProps {
  refreshBtnClick: boolean;
}

export default function RangeSlider({ refreshBtnClick }: RangeSliderProps) {
  const sliderValue = useRecoilValue(matchingRangeState);

  const [rangeModal, setRangeModal] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [labelText, setLabelText] = useState("파티 기간");
  const [value, setValue] = useState([
    sliderValue[0] === 0 ? 1 : sliderValue[0],
    sliderValue[1] === 0 ? 12 : sliderValue[1],
  ]);

  useEffect(() => {
    if (isChanged) {
      setLabelText(`${value[0]}~${value[1]}개월`);
    }
  }, [value, isChanged]);

  useEffect(() => {
    // 초기화 버튼 클릭시
    if (refreshBtnClick) {
      setIsChanged(false);
      setLabelText("파티 기간");
      setValue([2, 12]);
    }
  }, [refreshBtnClick]);

  return (
    <RangeSliderContainer>
      <RangeSliderBox onClick={() => setRangeModal(true)}>
        <RangeText style={{ color: isChanged ? "#333333" : "#858c97" }}>
          {labelText}
        </RangeText>

        <Arrow className="material-icons-outlined">arrow_drop_down</Arrow>
      </RangeSliderBox>

      {rangeModal && (
        <RangeModal
          closeEvent={() => setRangeModal(false)}
          setIsChanged={setIsChanged}
          value={value}
          setValue={setValue}
          isChanged={isChanged}
        />
      )}
    </RangeSliderContainer>
  );
}

const RangeSliderContainer = styled.div`
  position: relative;
`;

const RangeSliderBox = styled.div`
  cursor: pointer;
  width: 120px;
  height: 38px;
  border-radius: 3px;
  border: solid 1px #d4d9e1;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px 0 16px;
`;

const RangeText = styled.span`
  font-size: 14px;
  text-align: left;
  color: #858c97;
`;

const Arrow = styled.span`
  width: 24px;
  height: 24px;
  color: #858c97;
`;
